<template>
  <v-container fluid class="pl-md-5 pb-16">
    <v-alert dense outlined type="error" v-if="error">
      <ul>
        <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
      </ul>
    </v-alert>
    <div class="text-h5 mb-5">{{ $t("UploadImages") }}</div>
    <div class="elevation-1 pa-5 white mb-16">
      <v-form ref="form" class="pt-9 pb-5" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="11">
            <v-file-input
              type="file"
              v-model="file"
              show-size
              v-bind:label="$t('ClickHereSelectImage')"
              @change="uploadImage"
              accept="image/*"
              prepend-icon="mdi-camera"
              outlined
              dense
              persistent-hint
              v-bind:hint="$t('UploadImageHind')"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-form>
      <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
      <v-row v-if="!loading">
        <v-col v-for="(item, i) in pictures" :key="i" cols="2">
          <div class="d-flex pb-4">
            <v-select
              width="50"
              :items="range(0, 99)"
              v-bind:label="$t('Order')"
              outlined
              v-model="item.order"
              @change="orderChange(item)"
              dense
              hide-details
            ></v-select>
            <v-btn icon color="red" @click="removeImg(item)">
              <v-icon>mdi-delete-circle</v-icon>
            </v-btn>
          </div>
          <v-img
            :src="
              $store.state.baseUrl + 'listing/thumb320x240-' + item.file_name
            "
            aspect-ratio="1"
            max-width="100%"
            height="auto"
            class="grey lighten-2"
          ></v-img>
          <div class="pt-4">
            <v-text-field
              type="text"
              v-model="item.caption"
              v-bind:label="$t('Caption')"
              outlined
              @blur="saveCaption(item)"
              dense
            ></v-text-field>
          </div>
        </v-col>
      </v-row>
    </div>
    <WaitDialogComponent :waitDialog="waitDialog" />
    <v-footer fixed>
      <v-col class="text-center" cols="12">
        <v-btn
          color="light-blue"
          dark
          min-width="150"
          :to="{
            name: 'PartnerListingViewComponent',
            params: { id: parm }
          }"
        >
          <span>{{ $t("Done") }}</span>
        </v-btn>
      </v-col>
    </v-footer>
  </v-container>
</template>

<script>
// @ is an alias to /src
import timeoutMixin from "@/mixins/timeoutMixin.js";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import ListingService from "@/services/ListingService";
import swal from "sweetalert";

export default {
  name: "EditImagesComponent",
  components: { WaitDialogComponent },
  mixins: [timeoutMixin],
  data() {
    return {
      loading: true,
      waitDialog: false,
      parm: this.$route.params.id,
      pictures: null,
      valid: null,
      file: null,
      error: null
    };
  },
  created() {
    ListingService.getImages({
      id: this.parm
    }).then(result => {
      this.pictures = result.data;
      this.loading = false;
    });
  },
  methods: {
    range(start, end) {
      return Array(end - start + 1)
        .fill()
        .map((_, idx) => start + idx);
    },
    async uploadImage() {
      if (this.file) {
        this.waitDialog = true;
        let formData = new FormData();
        formData.append("property_id", this.parm);
        formData.append("file", this.file);
        console.log(JSON.stringify(formData));
        await ListingService.uploadImage(formData)
          .then(result => {
            this.waitDialog = false;
            this.pictures = result.data;
            this.file = null;
            this.$refs.form.reset();
          })
          .catch(err => {
            this.error = err.response.data.errors;
            this.file = null;
            this.caption = "";
            this.$refs.form.reset();
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    },
    removeImg(data) {
      swal({
        text: this.$t("string691"),
        className: "custom-confirm",
        buttons: {
          cancel: this.$t("No"),
          confirm: this.$t("Yes")
        }
      }).then(value => {
        if (value) {
          this.waitDialog = true;
          ListingService.imageDelete({
            id: data._id,
            property_id: this.parm
          })
            .then(result => {
              this.waitDialog = false;
              this.pictures = result.data;
            })
            .catch(err => {
              this.error = err.response.data.errors;
              setTimeout(() => (this.waitDialog = false), 500);
            });
        }
      });
    },
    async orderChange(data) {
      this.waitDialog = true;
      await ListingService.imageOrder({
        id: data._id,
        order: data.order,
        property_id: this.parm
      })
        .then(result => {
          this.waitDialog = false;
          this.pictures = result.data;
        })
        .catch(err => {
          this.error = err.response.data.errors;
          setTimeout(() => (this.waitDialog = false), 500);
        });
    },
    async saveCaption(data) {
      if (data.caption) {
        this.waitDialog = true;
        await ListingService.imageCaption({
          id: data._id,
          caption: data.caption,
          property_id: this.parm
        })
          .then(result => {
            this.waitDialog = false;
            this.pictures = result.data;
          })
          .catch(err => {
            this.error = err.response.data.errors;
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    }
  }
};
</script>

<style></style>
